<template>
  <v-card class="AuCard pa-0 ma-0"
          v-bind="$attrs"
          v-on="$listeners"
          flat
  >
    <template v-for="(_, slot) of $scopedSlots"
              v-slot:[slot]="scope">
      <slot :name="slot"
            v-bind="scope"/>
    </template>
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: "TcnAuCard"
}
</script>
